module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copypage how-it-works"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("How it works")]), _vm._v(" "), _c('h3', [_vm._v("PEI exChange - Exchange ideas, drive change for Africa")]), _vm._v(" "), _c('p', [_vm._v("The first matching platform for people committed to African development")]), _vm._v(" "), _c('p', [_vm._v("The exChange is a growing online network of people truly passionate about African development.")]), _vm._v(" "), _c('p', [_vm._v("Get matched with people based on shared geographic, industrial focuses and specialisms. Connect, chat and exchange knowledge to make your Big Ideas for Africa a reality. Showcase your project, whatever its stage, and get recognition and exposure.")]), _vm._v(" "), _c('h4', [_vm._v("How the exChange works:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26aaf0e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HowItWorks.vue
// module id = 695
// module chunks = 1